var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_170495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40009 12.0393C3.25139 11.5478 4.21708 11.2891 5.20009 11.2891C6.18309 11.2891 7.14878 11.5478 8.00009 12.0393C8.85139 11.5478 9.81708 11.2891 10.8001 11.2891C11.7831 11.2891 12.7488 11.5478 13.6001 12.0393",
    stroke: "#FD3C2F",
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39999 3.95045C3.2513 3.45895 4.21699 3.2002 5.19999 3.2002C6.183 3.2002 7.14869 3.45895 7.99999 3.95045C8.8513 3.45895 9.81699 3.2002 10.8 3.2002C11.783 3.2002 12.7487 3.45895 13.6 3.95045",
    stroke: "#FD3C2F",
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40009 3.9502V12.0391",
    stroke: "#FD3C2F",
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00009 3.9502V12.0391",
    stroke: "#FD3C2F",
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 3.9502V12.0391",
    stroke: "#FD3C2F",
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_170495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagProgram);
export default __webpack_public_path__ + "static/media/icon_search_tag_program.8b858c537463f1dea0361d3b3e3c0752.svg";
export { ForwardRef as ReactComponent };